import { render, staticRenderFns } from "./ArchivesProcessDetail.vue?vue&type=template&id=297c978f&scoped=true&"
import script from "./ArchivesProcessDetail.vue?vue&type=script&lang=js&"
export * from "./ArchivesProcessDetail.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesProcessDetail.vue?vue&type=style&index=0&id=297c978f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c978f",
  null
  
)

export default component.exports